import React from 'react';
export const Close = () => (React.createElement("svg", { width: "14", height: "13", viewBox: "0 0 14 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { id: "Group 418" },
        React.createElement("path", { id: "Vector 22", d: "M13 0.5L1 12.5", stroke: "#37404A" }),
        React.createElement("path", { id: "Vector 23", d: "M0.999999 0.500001L13 12.5", stroke: "#37404A" }))));
